import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-top-area">
            <div className="row d-flex justify-content-sm-start justify-content-center gy-5">
              <div className="col-lg-5 col-md-6 text-sm-start">
                <div className="footer-left-address">
                  <Link to={`${process.env.PUBLIC_URL}/`} onClick={scrollTop}>
                    {/* <img
                      src={process.env.PUBLIC_URL + "/images/icon/logo.png"}
                      className="footer-logo"
                      alt="images"
                    /> */}
                       <img src={process.env.PUBLIC_URL + "/images/icon/Frame 11 (1).svg"}  className="footer-logo" height="25" alt="images" />
                  </Link>
                  <ul className="address-list">
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="mailto:info@geniusfixers.com"
                      >
                        Email: info@geniusfixers.com
                      </Link>
                    </li>
                    <li>
                      <Link onClick={scrollTop} to={"#"}>
                        Address: 9300 Forest Point Circle, Suite 165
                        Manassas, Virginia, 20110
                      </Link>
                    </li>
                    <li>
                      <a href="tel:+1 (703) 419-9000">
                        Phone: +1 (703) 419-9000
                      </a>
                    </li>
                  </ul>
                  <div className="newsletter-area">
                    <h5>Get The Updates</h5>
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="form-inner">
                        <input type="text" placeholder="Type your Email :" />
                        <Link
                          onClick={scrollTop}
                          to={"#"}
                          className="newsletter-btn hover-btn"
                        >
                          <span>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/images/icon/nletter-arrow.svg"
                              }
                              alt="images"
                            />
                          </span>
                        </Link>
                      </div>
                      <p>We only send interesting and relevant emails.</p>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-6">
                <div className="footer-right-area">
                  <div className="row g-4">
                    <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-sm-start">
                      <div className="footer-item text-sm-start">
                        <h5 className="footer-title">Explore On</h5>
                        <ul className="footer-link">
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/`}
                              onClick={scrollTop}
                            >
                              Home
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/solution`}
                              onClick={scrollTop}
                            >
                             Solution
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/service`}
                              onClick={scrollTop}
                            >
                              service
                            </Link>
                          </li>


                          {/* <li><a href="#">List With Sidebar</a></li> */}
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 d-flex justify-content-sm-start">
                      <div className="footer-item text-sm-start">
                        <h5 className="footer-title">Our Services</h5>
                        <ul className="footer-link">
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/#`}
                              onClick={scrollTop}
                            >
                           Mobile App Development

                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/#`}
                              onClick={scrollTop}
                            >
                             
Web App Development

                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/#`}
                              onClick={scrollTop}
                            >
                      Block Chain Development
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/#`}
                              onClick={scrollTop}
                            >
                             Cloud Consulting
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={`${process.env.PUBLIC_URL}/#`}
                              onClick={scrollTop}
                            >
                       Data Science Consulting
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-5 col-md-12 d-flex justify-content-sm-start">
                      <div className="footer-item text-sm-start">
                        <h5 className="footer-title">Instagram Post</h5>
                        <SRLWrapper>
                          <ul className="gallery-list d-flex justify-content-sm-start flex-wrap gap-2">
                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe7-1.fna.fbcdn.net/v/t39.30808-6/302245916_601034841599023_7161945652848613386_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=a26aad&_nc_eui2=AeGgkaOYskSFAZ9SVxeHy1Ju2NvGjovZ-DDY28aOi9n4MHNVdJyMr4XF7EugqH4-SZN1E3mOYTfhRH8ajI0pyCDf&_nc_ohc=D9fQ6R8-BRgAX-qKDee&_nc_ht=scontent.flhe7-1.fna&oh=00_AfAfxkMOAqKcbx14SYb1NmeSrY6p0g8ZbepFcZXckkkFUQ&oe=640F6DEB"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>




                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/312981625_481180887361594_7050268605438667892_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeEY0cyt2q1kmWG3_lz3Lps_chr6Ctjir_pyGvoK2OKv-rxdmoME-DkNyhaCyTjHNJu2UYgPJIY5hDlIjbY8imVL&_nc_ohc=h7qTtkoeahoAX8ASHhX&_nc_ht=scontent.flhe3-1.fna&oh=00_AfDfIQ0zuHiQ7eftQHvUgWN1a6lN_WOwx2v5OY-T0bm1KQ&oe=64104868"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>



                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/325205532_1379852586092211_5754924342702929662_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeH9dqM8dpkQ8IbVvsf3uTnJDQrQ2mXp1nINCtDaZenWckOibxoq7dp_1kjnyhQGI9z82SEr0sAkDsxfzJ-aNyeG&_nc_ohc=5II5rWPpXzYAX-f9VIU&_nc_ht=scontent.flhe3-1.fna&oh=00_AfCDTDhyaDTvDF5wycEhe3Yywov7UpBB8iNXPMKkG-pJKQ&oe=64104F97"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>


                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/309379975_457695089710174_45463101037477502_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=19026a&_nc_eui2=AeH16amLNcBEqeBnYxgEcbQQyhvpIsirPfXKG-kiyKs99WDeYwNy9Wc7dxGlIicz4iv7urDmVgS643WYYe9pm6cc&_nc_ohc=MNHFyim-0sUAX8pau0p&_nc_ht=scontent.flhe3-1.fna&oh=00_AfD8LSL6Rno_sL-oKapz6NU4paEOWFqMsosKBDfOSGyjqQ&oe=640FCA60"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>

                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/256444485_417605366608639_6568388155633485271_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeELi3cVKIYagAhyu99WF5e_dL-YHsG8gbx0v5gewbyBvOVa4NXpr4-G77W3kCrwu_k9fkZ-ssum1kr4NNWY1R8A&_nc_ohc=VExh7U4ygNcAX_F5SSv&_nc_ht=scontent.flhe3-1.fna&oh=00_AfByC4XRnrMcy63dAPkDT8TNc5rgiJVTRYVSAInJwQ9sQA&oe=64112B8C"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>



                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/325214195_560835335928890_4279631600196229413_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeE6j8aU-Gn6ZWYlZPaEx0dM1ePdOllajAfV4906WVqMB6PrWBIFfdLLvKUaPGalgqUgt19wFTPAxjHBR7002JMl&_nc_ohc=VYdmw9TwqkMAX-hIVqg&_nc_ht=scontent.flhe3-1.fna&oh=00_AfAhvOLj3fHTWIdXg5uWfVE2-Ndub-qDopl9nZYe3pXy9Q&oe=6411156B"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>




                          </ul>
                        </SRLWrapper>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="footer-social-area d-flex justify-content-sm-start justify-content-center align-items-center flex-wrap">
                        <h5>Join Our Community</h5>
                        <ul className="footer-social-list">
                        <li><a rel="noopener noreferrer" href="https://twitter.com/Geniusfixers" target="_blank"><i className="bx bxl-twitter" /></a></li>
              <li><a rel="noopener noreferrer" href="https://www.facebook.com/" target="_blank"><i className="bx bxl-facebook" /></a></li>
              <li><a rel="noopener noreferrer" href="https://www.pinterest.com/" target="_blank"><i className="bx bxl-pinterest-alt" /></a></li>
              <li><a rel="noopener noreferrer" href="https://www.linkedin.com/company/89312628/admin/" target="_blank"><i className="bx bxl-instagram" /></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom-area">
            <div className="row">
              <div className="col-lg-5 text-lg-start text-center">
                <div className="footer-bottom-left">
                  <a
                    onClick={scrollTop}
                    rel="noopener noreferrer"
                    href="https://geniusfixers.com/"
                    target="_blank"
                  >
                    <h6 className="mb-0">
                      Copyright 2023 Genius Fixers | Design By <span>Genius Fixers LLC</span>
                    </h6>
                  </a>
                </div>
              </div>
              <div className="col-lg-7 text-lg-end text-center">
                <div className="footer-bottom-right">
                  <Link onClick={scrollTop} to={"#"}>
                    <h6 className="mb-0">Privacy Policy | Terms of Use</h6>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="scroll-btn show">
        <ScrollButton></ScrollButton>
      </div>
    </>
  );
}
const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 800) {
      setVisible(true);
    } else if (scrolled <= 100) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <i
      className="bx bxs-up-arrow-circle"
      onClick={scrollToTop}
      style={{ display: visible ? "inline" : "none" }}
    ></i>
  );
};

export default Footer;
